/* eslint-disable jsx-a11y/no-distracting-elements */
import React from 'react';
import styles from './ladderNews.module.scss';
import { ILadderService } from '../../model/interfaces';
import BlockHeading from '@ui-kit/components/blockHeading';
import { useAsyncData } from '@utils/hooks';
import { t } from '@base/utils/helpers';

export default function LadderNews(props: { ladderService: ILadderService }) {
  const { data: news } = useAsyncData(() => props.ladderService.getLadderNews());

  return (
    <>
      <BlockHeading className={styles.heading}>{t('ladder_news')}</BlockHeading>
      <ul className={styles.list}>
        {news?.map((n, index) => (
          <li key={index}>
            {n.time}: {n.news}
          </li>
        ))}
      </ul>
    </>
  );
}
